import type { WorkflowView } from "../api/client.js";

function compareWorkflows(left: WorkflowView, right: WorkflowView): number {
  return Date.parse(right.updatedAt) - Date.parse(left.updatedAt) || right.id.localeCompare(left.id);
}

export function mergeWorkflows(
  current: readonly WorkflowView[],
  incoming: readonly WorkflowView[]
): WorkflowView[] {
  const byId = new Map(current.map((workflow) => [workflow.id, workflow]));
  incoming.forEach((workflow) => {
    const existing = byId.get(workflow.id);
    if (!existing || Date.parse(workflow.updatedAt) >= Date.parse(existing.updatedAt)) {
      byId.set(workflow.id, workflow);
    }
  });
  return [...byId.values()].sort(compareWorkflows);
}

export function latestWorkflowId(workflows: readonly WorkflowView[]): string | undefined {
  return workflows[0]?.id;
}
